import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import SnackbarSettings from '../../../components/Snackbar/SnackbarSettings';
import Title from '../../../components/Title';
import * as Selectors from '../redux/usersSelectors';
import * as Actions from '../redux/usersActions';
import UsersDataGrid from './datagrid/UsersDataGrid';

const UsersList: FC = () => {
  const { t } = useTranslation();
  const apiRequestState = useSelector(Selectors.apiAllUsersRequestState);
  const apiRequestError = useSelector(Selectors.apiAllUsersRequestError);

  return (
    <>
      <SnackbarSettings
        hideSuccessMessage={true}
        apiRequestState={apiRequestState}
        apiRequestError={apiRequestError}
        setApiRequestState={Actions.setApiAllUsersRequestState}
      />
      <Title>{t('users.admins.list')}</Title>
      <UsersDataGrid />
    </>
  );
};

export default UsersList;
